// extracted by mini-css-extract-plugin
export default {"details":"o7nftwCaY-FJrvGKfNTD4g==","label":"JGwjN+A5EK5N390NRQegdQ=="};